// @flow

import React, { PureComponent } from 'react';
import DateFormat from '../../date/format';
import Translate from '../../translate';
import { titleCase } from '../../../utils/format';

type Props = {
  date: string | Date,
  descriptor: string,
  commonTranslations: Object,
  locale?: string,
};

export default class EffectiveDate extends PureComponent<Props> {
  static defaultProps = {
    locale: 'en-US',
  };

  render() {
    const { date, descriptor, commonTranslations, locale } = this.props;

    return (
      <span className="effective-date">
        <Translate path={descriptor} andThen={content => titleCase(content, null)} />
        &nbsp;
        <DateFormat
          date={date}
          formatString="MMM D, YYYY"
          commonTranslations={commonTranslations}
          locale={locale} />
      </span>
    );
  }
}
